<template>
  <div>
    <div v-if="loader">
      <div class="spinner"></div>
    </div>
    <!--  Banner Starts Here   -->
    <section class="inner_banner">
      <div class="container_large">
        <div class="inner_banner_content">
          <h1>Corporate Contracts</h1>
        </div>
      </div>
    </section>
    <!--  Banner Ends Here   -->

    <!--   Main Content Start Here   -->
    <main>
      <section class="default_wraper">
        <div class="container_large">
          <div class="terms_holder">
            <div class="row">
              <div class="col-md-6">
                <div class="form_group">
                  <p style="font-size: 20px">
                    Whether you are a Gym, Spa, School, Hotel…. Who needs 10,000
                    pounds or 50 pounds, Dirty Drawz is here to handle all your
                    laundry and towel service needs! You can rent our towels, or
                    we can clean yours! Whatever you need done, we are at your
                    service. Contact us today for a customized quote!!!.

                    <br /><br />
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="27"
                      height="27"
                      viewBox="0 0 27 27"
                    >
                      <path
                        id="Icon_material-phone"
                        data-name="Icon material-phone"
                        d="M9.93,16.185a22.723,22.723,0,0,0,9.885,9.885l3.3-3.3a1.491,1.491,0,0,1,1.53-.36A17.11,17.11,0,0,0,30,23.265a1.5,1.5,0,0,1,1.5,1.5V30A1.5,1.5,0,0,1,30,31.5,25.5,25.5,0,0,1,4.5,6,1.5,1.5,0,0,1,6,4.5h5.25A1.5,1.5,0,0,1,12.75,6a17.041,17.041,0,0,0,.855,5.355,1.505,1.505,0,0,1-.375,1.53l-3.3,3.3Z"
                        transform="translate(-4.5 -4.5)"
                        fill="#9cabc4"
                      ></path>
                    </svg>
                    <span class="pl-4"
                      ><a href="tel:877-973-7299">877-973-7299</a>
                    </span>
                    <br /><br />
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="36"
                      height="27.891"
                      viewBox="0 0 36 27.891"
                    >
                      <path
                        id="Icon_simple-minutemailer"
                        data-name="Icon simple-minutemailer"
                        d="M8.346,4.055l5.175,5.6-3.651,7.2,7.71-1.382,3.51,8.469L36,4.389ZM7.392,16.187l1.435-1.181-1.851.585-.189-.27.765-.743-1,.4A10.217,10.217,0,0,0,3.2,31.945a10.145,10.145,0,0,1-1.327-5.032,10.472,10.472,0,0,1,6.472-9.63l.472-1.149-1.125.5L7.375,16.2l.016-.017Zm6.546-2.955L16.335,9l14.1-3.3L13.938,13.231Z"
                        transform="translate(0 -4.055)"
                        fill="#9cabc4"
                      ></path>
                    </svg>
                    <span class="pl-4"
                      ><a href="mailto:info@dirtydrawz.com"
                        >info@dirtydrawz.com</a
                      >
                    </span>
                  </p>
                </div>
              </div>
              <div class="col-md-6">
                <img
                  src="/src/assets/images/commercial-img.jpg"
                  class="img-fluid"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
    <!--   Main Content End Here   -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      loader: true,
    };
  },
  created() {
    this.loader = false;
  },
};
</script>



// WEBPACK FOOTER //
// src/components/contracts.vue